/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ComplaintRecordQueryResponse2 } from './ComplaintRecordQueryResponse2';
import {
    ComplaintRecordQueryResponse2FromJSON,
    ComplaintRecordQueryResponse2FromJSONTyped,
    ComplaintRecordQueryResponse2ToJSON,
} from './ComplaintRecordQueryResponse2';

/**
 * 
 * @export
 * @interface DataComplaintQueryResponse2
 */
export interface DataComplaintQueryResponse2 {
    /**
     * 
     * @type {Array<ComplaintRecordQueryResponse2>}
     * @memberof DataComplaintQueryResponse2
     */
    data: Array<ComplaintRecordQueryResponse2>;
}

/**
 * Check if a given object implements the DataComplaintQueryResponse2 interface.
 */
export function instanceOfDataComplaintQueryResponse2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function DataComplaintQueryResponse2FromJSON(json: any): DataComplaintQueryResponse2 {
    return DataComplaintQueryResponse2FromJSONTyped(json, false);
}

export function DataComplaintQueryResponse2FromJSONTyped(json: any, ignoreDiscriminator: boolean): DataComplaintQueryResponse2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ComplaintRecordQueryResponse2FromJSON)),
    };
}

export function DataComplaintQueryResponse2ToJSON(value?: DataComplaintQueryResponse2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(ComplaintRecordQueryResponse2ToJSON)),
    };
}

